import types from './types';
import { SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS } from '../inventories/types';
import { SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS } from '../chemicalProducts/types';

const defaultState = {
  supplierList: [],
  isLoading: false
};

const updateSupplierList = (state, params) => {
  let { supplierList } = state;
  let chemicalProduct = params.inventory
    ? params.inventory.chemicalProduct
    : params.chemicalProduct;
  if (
    chemicalProduct != null &&
    chemicalProduct.supplier &&
    chemicalProduct.supplier.name &&
    !supplierList.some(c => c.name === chemicalProduct.supplier.name)
  ) {
    supplierList.push(chemicalProduct.supplier);
  }
  return supplierList;
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GET_SUPPLIER_LIST:
      return { ...state, isLoading: true };
    case types.GET_SUPPLIER_LIST_SUCCESS:
      return { ...state, supplierList: data, isLoading: false };
    case types.GET_SUPPLIER_LIST_FAILURE:
      return { ...state, isLoading: false };

    case SAVE_INVENTORY_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
    case SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL_SUCCESS:
      if (data.openConfirmationModal) return { ...state };
      else {
        let { supplierList } = state;
        supplierList = updateSupplierList(state, data);
        return {
          ...state,
          supplierList: supplierList
        };
      }

    default:
      return state;
  }
};
